<template>
  <div 
    class="input-date-time"
    :class="[
			darkMode ? 'dark-mode' : '',
      noMargin ? 'no-margin' : '',
    ]"
    >
    <label>{{ label }}</label>
    <DatePicker 
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', formattedDate($event))"
      :mode="mode"
      is24hr 
      :masks="{ title: mode == 'time' ? '[Time]' : 'MMM YYYY' }"
      is-dark
      v-if="!disabled"
      :min-date='minToday ? new Date() : null'
      >
      <template v-slot="{ inputValue, inputEvents }">
        <input
          :value="inputValue"
          v-on="inputEvents"
          :placeholder="`Please set a date${ mode == 'dateTime' ? ' and time' : ''}`"
        />
      </template>
    </DatePicker>

    <input
      v-else
			:value="modelValue"
      disabled
      />

  </div>
</template>

<script>

import { Calendar, DatePicker } from 'v-calendar';
import moment from 'moment'

export default {
  components: {
    Calendar,
    DatePicker
  },
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: [String, Date],
      required: true
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'date'
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minToday: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  methods: {
    formattedDate(theDate) {
      if(this.mode == 'date'){
        return moment(theDate).format('YYYY-MM-DD')
      }
      if(this.mode == 'dateTime'){
        return moment(theDate).format('YYYY-MM-DD HH:mm')
      }
      if(this.mode == 'time'){
        return moment(theDate).format('HH:mm')
      }
    }
  }
}

</script>

<style scoped lang="sass">

.input-date-time
  margin: 0 0 30px
  display: flex
  flex-direction: column
  width: 100%
  // max-width: 30rem

  label
    font-family: 'Roboto Condensed', sans-serif
    font-weight: 700
    font-size: 16px
    line-height: 1.1
    color: #252525
    margin-bottom: 10px

  input
    width: 100%
    border-radius: 3px
    border: 1px solid lighten(#111, 70%)
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05)
    padding: 0.5rem 0.75rem

  &.dark-mode
    label
      color: rgba(#fff, 0.7)

    input
      background-color: rgba(#fff,0.2)
      color: #fff

      &::placeholder
        color: rgba(#fff,0.6)

  &.no-margin
    margin: 0

</style>